

















import { VueCustom, CustomVueConstructor } from 'vue-custom';
import { GAME_READY, PLAY, PLAY_NOT_READY } from 'constants/events';
import { emitNativeEvent } from 'helpers/events';
import { getVariant } from 'helpers/experiment';
import { delay } from '../utils';
import { load, save } from '../helpers/storage';

type AutohideVariant = 'original' | 'hide' | 'hideAfterDelay';
const HIDE_DELAY = 1.1 * 1000;

type ComponentCustom = {
  $refs: {
    logo: HTMLImageElement,
  },
};
export default (VueCustom as CustomVueConstructor<ComponentCustom>).extend({
  name: 'loading-screen',
  data: () => ({
    visible: true,
    clicked: false,
    ready: false,
  }),
  computed: {
    classes(): Record<string, boolean> {
      return {
        'js-ready': this.ready,
      };
    },
  },
  mounted() {
    this.$refs.logo.src = '/static/img/logo.svg';

    this.onGameReady = this.onGameReady.bind(this);
    document.addEventListener(GAME_READY, this.onGameReady, false);

    // remove listener as loading screen now will handle events
    const button = document.querySelector('#loading-screen .btn');
    if (!button) return;
    button.removeEventListener('mousedown', window.playClickNotReady, false);
    button.removeEventListener('touchstart', window.playClickNotReady, false);
    (window as any).playClickNotReady = null;
  },
  methods: {
    onClick() {
      this.clicked = true;
      this.checkPlay();
    },
    async onGameReady() {
      document.removeEventListener(GAME_READY, this.onGameReady, false);

      const autohide = this.getAutohideVariant();
      if (autohide === 'hide') {
        // await a moment just to make sure everything is loaded
        await delay(30);
        this.play();
      } else if (autohide === 'hideAfterDelay') {
        await delay(HIDE_DELAY);
        this.play();
      } else {
        this.ready = true;
        this.checkPlay();
      }
    },
    checkPlay() {
      if (!this.ready || !this.clicked) {
        if (!this.ready) {
          emitNativeEvent(PLAY_NOT_READY);
        }

        return;
      }

      this.play();
    },
    play() {
      emitNativeEvent(PLAY);

      this.visible = false;
      this.$nextTick(() => this.$destroy());
    },

    getAutohideVariant() {
      const STORAGE_KEY = 'experiment-auto-hide';
      let variant = load<AutohideVariant>(STORAGE_KEY);
      if (variant !== null) return variant;

      variant = getVariant('O_ZkAo4qS_yyPKq34rk6FA', { 1: 'hide', 2: 'hideAfterDelay' }) as AutohideVariant;

      save(STORAGE_KEY, variant);
      return variant;
    },
  },
});
